import { z, type infer as zInfer } from "zod";
import { timestamp } from "@/hooks/firestore/models/timestamp";
import { promotionCampaign } from "@/hooks/firestore/models/promotionCampaign";

const exoticMarketTypes = z.enum(["QUINELLA", "EXACTA", "TRIFECTA", "FIRST_4"]);

export const racingEventStatusEnum = z.enum([
  "OPEN",
  "CLOSED",
  "CANCELLED",
  "INTERIM",
  "PROTEST",
  "FINAL",
  "DONE",
  "JUMPED",
  "ABANDONED",
]);

export const racingEvent = z.object({
  distance: z.string(),
  meetingDate: z.string(),
  meetingId: z.string(),
  meetingTrackType: z.string().optional(),
  name: z.string(),
  number: z.number(),
  scheduledStartTime: z.string(),
  scheduledStartTimeTs: timestamp,
  status: racingEventStatusEnum,
  venue: z.string(),
  silksUrl: z.string().optional(),
  results: z.record(z.string(), z.string()),
  comment: z.string().nullish(),
  sport: z.enum(["HORSE_RACING", "GREYHOUNDS", "HARNESS_RACING"]),
  region: z.enum(["ANZ", "ROW"]),
  promotionIsAvailable: z.boolean().optional(),
  venueCountry: z.string(),
  venueState: z.string().optional(),
  trackType: z.string().nullish(),
  semAvailableAtTs: timestamp.optional(),
  filters: z.array(z.string()).optional(),
  exoticResults: z.record(
    exoticMarketTypes,
    z
      .record(
        z.string(),
        z.object({
          dividend: z.number(),
          outcomeIds: z.array(z.string()),
          runners: z.array(z.number()),
        }),
      )
      .optional(),
  ),
  visible: z.boolean().optional(),
  promotionCampaigns: z.array(promotionCampaign).optional(),
  hasPromotionalMarkets: z.boolean().optional(),
  showPromoBanner: z.boolean().optional(),
  expectedResults: z.record(z.string(), z.number()),
  closeTime: z.string().optional(),
  eventClass: z.string().optional(),
  surface: z.string().optional(),
  streams: z
    .record(
      z.string(),
      z.object({
        type: z.enum(["BM_RACING_CHANNEL"]),
        url: z.string(),
      }),
    )
    .optional(),
});

export type RacingEvent = zInfer<typeof racingEvent>;
export type ExoticMarketTypes = zInfer<typeof exoticMarketTypes>;
export type RacingEventStatus = zInfer<typeof racingEventStatusEnum>;
